import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <span className="ms-1">TMPL Admin</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <span className="me-1">TMPL</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
